import { contractionList } from "@/utils/const";

export function CheckAge(value, params, callback, message) {

  if (value > params) {
    callback(new Error(message))
  } else {
    callback()
  }
}
/**
 * Custom validate real number function
 * @param {{field, fullField,message,required,type}} rule The validation rule in the source descriptor that corresponds to the field name being validated.
 * @param {*} value The value of the source object property being validated.
 * @param {*} params The params in file domain.json defined.
 * @param {Function} callback A sync callback function to invoke once validation is complete.
 * @param {String} message The message is self defined or in file rules.js defined.
 */
export function CheckRealNumber(value, params, callback, message) {
  if (value) {
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(String(value))) {
      callback(new Error(message))
    } else {
      const validValue = String(value).split('.')
      if (validValue[1] && String(validValue[1]).length > params[1]) {
        callback(new Error(message))
      } else if (String(validValue[0]).length > params[0]) {
        callback(new Error(message))
      } else {
        callback()
      }
    }
  } else {
    callback()
  }
}

export function CheckDate(value, params, callback, message) {
  if (value) {
    //获取当前时间
    let today = new Date()
    let y = today.getFullYear()
    let m = (today.getMonth() + 1).toString().padStart(2, '0')
    let d = today.getDate().toString().padStart(2, '0')

    let startTime = y + m + d
    if (startTime > value) {
      callback(new Error(message))
    } else {
      callback()
    }
  } else {
    callback()
  }
}

export function CheckRealNumberRules(rules, value, callback) {
  if (value) {
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(String(value))) {
      callback(new Error(rules.message))
    } else {
      const validValue = String(value).split('.')
      if (validValue[1] && String(validValue[1]).length > rules.params[1]) {
        callback(new Error(rules.message))
      } else if (String(validValue[0]).length > rules.params[0]) {
        callback(new Error(rules.message))
      } else {
        callback()
      }
    }
  } else {
    callback()
  }
}

export function MinValue(value, params, callback, message) {

  if (value == null ||  value < params ) {
    callback(new Error(message))
  } else {
    callback()
  }
}

export function MaxValue(value, params, callback, message) {

  if (value == null ||  value > params ) {
    callback(new Error(message))
  } else {
    callback()
  }
}

export function ValidateUniqueChars(value, params, callback, message) {

  if (contractionList.key.includes(value)) {
    callback(new Error(message))
  }

  callback()
}
